/** OptimizedWorkoutForm + shared recurrence settings UI */

export const TRAINER_FORMS_RU = {
  'optForm.batchUnknownDate': 'Неизвестная дата',
  'optForm.batchBusy': 'занято: {clients}',
  'optForm.duration30': '30 минут',
  'optForm.duration45': '45 минут',
  'optForm.duration60': '1 час',
  'optForm.duration90': '1.5 часа',
  'optForm.duration120': '2 часа',
  'optForm.durationCustom': 'Другое',

  'optForm.errPickClient': 'Выберите хотя бы одного клиента',
  'optForm.errPickDate': 'Укажите дату тренировки',
  'optForm.errPickStartTime': 'Укажите время начала тренировки',
  'optForm.errPickDuration': 'Укажите продолжительность тренировки',
  'optForm.errRecurrenceDuplicateSlot': 'Нельзя выбрать одинаковые день недели и время дважды',
  'optForm.errRecurrenceWeeks': 'Введите количество повторений (недель)',
  'optForm.errRecurrenceEndDate': 'Укажите дату окончания повторения',
  'optForm.errRecurrenceEndBeforeStart': 'Дата окончания не может быть раньше даты тренировки',
  'optForm.errNoClientWorkout': 'Не выбран клиент для тренировки',
  'optForm.errBuildSchedule': 'Не удалось построить расписание. Проверьте параметры повторения.',
  'optForm.scheduleConflictIntro': 'Время занято:',
  'optForm.timeAlreadyTaken': 'Данное время уже выбрано',
  'optForm.successBatchPartial': 'Создано {created} из {planned} тренировок{suffix}',
  'optForm.successBatchConflictsSuffix': '. Некоторые даты конфликтовали',
  'optForm.errSaveWorkout': 'Не удалось {verb} тренировку',
  'optForm.verbUpdate': 'обновить',
  'optForm.verbCreate': 'создать',
  'optForm.errCreateBatch': 'Не удалось создать тренировки',
  'optForm.errCreateWorkout': 'Не удалось создать тренировку',

  'optForm.titleEdit': 'Редактирование тренировки',
  'optForm.titleCreate': 'Создание тренировки',
  'optForm.successUpdated': 'Тренировка успешно обновлена!',
  'optForm.successCreated': 'Тренировка успешно создана!',

  'optForm.labelClient': 'Клиент *',
  'optForm.phClient': 'Выберите клиента',
  'optForm.labelWorkoutDate': 'Дата тренировки *',
  'optForm.labelStartTime': 'Время начала *',
  'optForm.labelDuration': 'Продолжительность *',
  'optForm.durationPlaceholder': 'Выберите продолжительность',
  'optForm.labelEndTime': 'Время окончания *',
  'optForm.endsAt': 'Окончание: {time}',

  'optForm.recurrenceHeading': 'Повторение',
  'optForm.recurrenceAdded': 'Добавлено: {n}',
  'optForm.recurrenceNoRepeat': 'Не повторять',
  'optForm.recurrenceEmpty': 'Нет добавленных повторений',
  'optForm.recurrenceEmptyHint': 'Добавьте день и время, чтобы начать',
  'optForm.addDayTime': 'Добавить день и время',
  'optForm.labelWeekday': 'День недели',
  'optForm.labelTimeShort': 'Время',

  'optForm.recurrenceEndTitle': 'Завершение повторения *',
  'optForm.recurrenceEndWeeksOpt': 'Количество недель',
  'optForm.recurrenceEndDateOpt': 'До даты',
  'optForm.phWeeksCount': 'Введите количество повторений',
  'optForm.ariaRecurrenceEndMethod': 'Способ завершения повторения',
  'optForm.ariaRecurrenceWeeks': 'Количество недель повторения',
  'optForm.ariaRecurrenceEndDate': 'Дата окончания повторения',

  'optForm.labelLocation': 'Локация',
  'optForm.labelGymName': 'Название зала *',
  'optForm.phGymName': 'Введите название зала',
  'optForm.labelGymAddress': 'Адрес зала',
  'optForm.phGymAddress': 'Введите адрес зала',
  'optForm.saving': 'Сохранение...',
  'optForm.save': 'Сохранить',
  'optForm.selectLocation': 'Выберите локацию',
  'optForm.online': 'Онлайн',
  'optForm.addNewGym': '+ Добавить новый зал',

  'optForm.commentLabel': 'Комментарий',
  'optForm.commentPlaceholder': 'Введите комментарий',
  'optForm.commentApplyAria': 'Применить комментарий ко всем тренировкам в серии',
  'optForm.commentApplyAll': 'Применить ко всем тренировкам',

  'optForm.deleteWorkout': 'Удалить тренировку',

  'optForm.discardTitle': 'Отменить изменения?',
  'optForm.discardDesc':
    'У вас есть несохраненные изменения. Вы уверены, что хотите закрыть форму?',
  'optForm.discardConfirm': 'Отменить изменения',

  'optForm.conflictTitle': 'На это время уже есть другая тренировка',
  'optForm.conflictAsk': 'Создать всё равно?',
  'optForm.conflictBatchHeading': 'Занятые слоты в серии (день недели, дата и время):',
  'optForm.conflictSingleHeading': 'Пересекающиеся тренировки:',
  'optForm.clientFallback': 'Клиент',
  'optForm.conflictWorkoutWhen': '{date} в {time}{end}',
  'optForm.conflictEndDash': ' – {end}',
  'optForm.hide': 'Скрыть',
  'optForm.showMore': 'Показать ещё ({n})',
  'optForm.conflictNo': 'Нет',
  'optForm.conflictCreating': 'Создание...',
  'optForm.conflictYes': 'Создать всё равно',

  'recurrenceUi.type.none': 'Не повторять',
  'recurrenceUi.type.daily': 'Ежедневно',
  'recurrenceUi.type.weekly': 'Еженедельно',
  'recurrenceUi.type.monthly': 'Ежемесячно',
  'recurrenceUi.type.weekdays': 'Каждый будний день',
  'recurrenceUi.type.custom': 'Пользовательский',

  'recurrenceUi.freq.daily': 'Каждый день',
  'recurrenceUi.freq.weekly': 'Каждую неделю',
  'recurrenceUi.freq.monthly': 'Каждый месяц',
  'recurrenceUi.freq.yearly': 'Каждый год',
  'recurrenceUi.freq.interval': 'Через N …',

  'recurrenceUi.interval.days': 'дней',
  'recurrenceUi.interval.weeks': 'недель',
  'recurrenceUi.interval.months': 'месяцев',

  'recurrenceUi.end.never': 'Не заканчивать',
  'recurrenceUi.end.count': 'Заканчивать после X вхождений',
  'recurrenceUi.end.date': 'Заканчивать в дату',

  'recurrenceUi.labelRecurrence': 'Повторение',
  'recurrenceUi.titleCustomSettings': 'Настройки повторения',
  'recurrenceUi.labelFrequency': 'Частота',
  'recurrenceUi.labelInterval': 'Интервал',
  'recurrenceUi.labelIntervalType': 'Тип',
  'recurrenceUi.labelWeekdays': 'Дни недели',
  'recurrenceUi.labelEnd': 'Заканчивать',
  'recurrenceUi.labelEndCount': 'Количество вхождений',
  'recurrenceUi.labelEndDate': 'Дата окончания',
  'recurrenceUi.titleEndSection': 'Завершение повторения',
  'recurrenceUi.labelEndTypeTop': 'Заканчивать',
  'recurrenceUi.labelRepeatCount': 'Количество повторений',
  'recurrenceUi.phRepeatExample': 'Например: 10',
  'recurrenceUi.hintRepeatCount': 'Тренировка будет повторяться указанное количество раз',
  'recurrenceUi.labelEndDateSection': 'Дата окончания',
  'recurrenceUi.hintEndDate': 'Тренировка будет повторяться до указанной даты включительно',

  'recurrenceUi.summaryNone': 'Не повторять',
  'recurrenceUi.summaryPrefix': 'Повтор: ',
  'recurrenceUi.summaryDaily': 'ежедневно',
  'recurrenceUi.summaryWeekly': 'еженедельно',
  'recurrenceUi.summaryMonthly': 'ежемесячно',
  'recurrenceUi.summaryWeekdays': 'каждый будний день',
  'recurrenceUi.summaryEveryNDays': 'каждые {n} дня',
  'recurrenceUi.summaryEveryNWeeks': 'каждые {n} недели',
  'recurrenceUi.summaryEveryNMonths': 'каждые {n} месяца',
  'recurrenceUi.summaryEveryDayFallback': 'каждый день',
  'recurrenceUi.summaryOnDays': ' по {days}',
  'recurrenceUi.summaryNTimes': ' ({n} раз)',
  'recurrenceUi.summaryUntil': ' до {date}',

  'createWorkout.saving': 'Создание…',
  'createWorkout.errPickEndTime': 'Укажите время окончания тренировки',
  'createWorkout.errEndAfterStart': 'Время окончания должно быть позже времени начала',
  'createWorkout.errRecurrenceFrequency': 'Укажите частоту повторения',
  'createWorkout.errPickWeekday': 'Выберите хотя бы один день недели',
  'createWorkout.labelClients': 'Клиент(ы) *',
  'createWorkout.phClients': 'Выберите клиента или начните вводить имя',
  'createWorkout.phStartTime': 'Выберите дату и время начала',
  'createWorkout.labelEndTime': 'Время окончания *',
  'createWorkout.phEndTime': 'Выберите дату и время окончания',
  'createWorkout.phLocation': 'Выберите или введите локацию',
  'createWorkout.locationNotFound': 'Локация не найдена',
  'createWorkout.locGym': 'Спортзал',
  'createWorkout.locHome': 'Дома',
  'createWorkout.locOutdoor': 'На улице',
  'createWorkout.locOnline': 'Онлайн',

  'exerciseAnalytics.tabSummary': 'Сводка',
  'exerciseAnalytics.tabHistory': 'История',
  'exerciseAnalytics.progressTitle': 'График прогресса',
  'exerciseAnalytics.progressDesc': 'Динамика показателей по датам',
  'exerciseAnalytics.metricHeaviestShort': 'Рабочий вес',
  'exerciseAnalytics.metricVolumeShort': 'Объём',
  'exerciseAnalytics.metricHeaviestAxis': 'Рабочий вес (кг)',
  'exerciseAnalytics.metricVolumeAxis': 'Объём (кг)',
  'exerciseAnalytics.timeWeek': 'Неделя',
  'exerciseAnalytics.timeMonth': 'Месяц',
  'exerciseAnalytics.timeYear': 'Год',
  'exerciseAnalytics.timeAll': 'Всё время',
  'exerciseAnalytics.loadingChart': 'Загрузка данных…',
  'exerciseAnalytics.noChartData': 'Нет данных для отображения',
  'exerciseAnalytics.recordsTitle': 'Личные рекорды',
  'exerciseAnalytics.recordsDesc': 'Лучшие показатели за всё время',
  'exerciseAnalytics.workingWeight': 'Рабочий вес',
  'exerciseAnalytics.editWorkingWeightTitle': 'Редактировать рабочий вес',
  'exerciseAnalytics.bestSetVolume': 'Лучший объём подхода',
  'exerciseAnalytics.bestSessionVolume': 'Лучший объём тренировки',
  'exerciseAnalytics.noData': 'Нет данных',
  'exerciseAnalytics.loadingShort': 'Загрузка…',
  'exerciseAnalytics.editWwDialogTitle': 'Рабочий вес',
  'exerciseAnalytics.editWwDialogDesc':
    'Установите ручной рабочий вес для упражнения «{name}». Можно оставить пустым, чтобы сбросить.',
  'exerciseAnalytics.labelWwKg': 'Рабочий вес (кг)',
  'exerciseAnalytics.phWw': 'Например, 40',
  'exerciseAnalytics.errInvalidWeight': 'Введите корректное значение веса',
  'exerciseAnalytics.errUpdateWeight': 'Ошибка при обновлении рабочего веса',
  'exerciseAnalytics.saving': 'Сохранение…',
  'exerciseAnalytics.loadingHistory': 'Загрузка истории…',
  'exerciseAnalytics.unknownDate': 'Неизвестная дата',
  'exerciseAnalytics.openWorkout': 'Открыть тренировку',
  'exerciseAnalytics.setN': 'Подход {n}',
  'exerciseAnalytics.weight': 'Вес',
  'exerciseAnalytics.reps': 'Повторения',
  'exerciseAnalytics.noSetData': 'Нет данных о подходах',
  'exerciseAnalytics.noHistory': 'Нет истории выполнения упражнения',
  'exerciseAnalytics.tooltipHeaviestUpdated': 'Рабочий вес (обновлено)',
  'exerciseAnalytics.tooltipDate': 'Дата: {date}',
  'exerciseAnalytics.kgValue': '{value} кг',
  'exerciseAnalytics.emDash': '—',
};

export const TRAINER_FORMS_EN = {
  'optForm.batchUnknownDate': 'Unknown date',
  'optForm.batchBusy': 'busy: {clients}',
  'optForm.duration30': '30 minutes',
  'optForm.duration45': '45 minutes',
  'optForm.duration60': '1 hour',
  'optForm.duration90': '1.5 hours',
  'optForm.duration120': '2 hours',
  'optForm.durationCustom': 'Other',

  'optForm.errPickClient': 'Select at least one client',
  'optForm.errPickDate': 'Choose the workout date',
  'optForm.errPickStartTime': 'Choose the start time',
  'optForm.errPickDuration': 'Choose the duration',
  'optForm.errRecurrenceDuplicateSlot': 'You can’t use the same weekday and time twice',
  'optForm.errRecurrenceWeeks': 'Enter the number of weeks to repeat',
  'optForm.errRecurrenceEndDate': 'Choose the series end date',
  'optForm.errRecurrenceEndBeforeStart': 'End date can’t be before the workout date',
  'optForm.errNoClientWorkout': 'No client selected for this workout',
  'optForm.errBuildSchedule': 'Couldn’t build the schedule. Check your repeat settings.',
  'optForm.scheduleConflictIntro': 'Time unavailable:',
  'optForm.timeAlreadyTaken': 'That time is already taken',
  'optForm.successBatchPartial': 'Created {created} of {planned} workouts{suffix}',
  'optForm.successBatchConflictsSuffix': '. Some dates had conflicts',
  'optForm.errSaveWorkout': 'Couldn’t {verb} workout',
  'optForm.verbUpdate': 'update',
  'optForm.verbCreate': 'create',
  'optForm.errCreateBatch': 'Couldn’t create workouts',
  'optForm.errCreateWorkout': 'Couldn’t create workout',

  'optForm.titleEdit': 'Edit workout',
  'optForm.titleCreate': 'New workout',
  'optForm.successUpdated': 'Workout updated!',
  'optForm.successCreated': 'Workout created!',

  'optForm.labelClient': 'Client *',
  'optForm.phClient': 'Select a client',
  'optForm.labelWorkoutDate': 'Workout date *',
  'optForm.labelStartTime': 'Start time *',
  'optForm.labelDuration': 'Duration *',
  'optForm.durationPlaceholder': 'Select duration',
  'optForm.labelEndTime': 'End time *',
  'optForm.endsAt': 'Ends at: {time}',

  'optForm.recurrenceHeading': 'Repeat',
  'optForm.recurrenceAdded': 'Added: {n}',
  'optForm.recurrenceNoRepeat': 'Does not repeat',
  'optForm.recurrenceEmpty': 'No repeat slots yet',
  'optForm.recurrenceEmptyHint': 'Add a weekday and time to get started',
  'optForm.addDayTime': 'Add weekday & time',
  'optForm.labelWeekday': 'Weekday',
  'optForm.labelTimeShort': 'Time',

  'optForm.recurrenceEndTitle': 'End of series *',
  'optForm.recurrenceEndWeeksOpt': 'Number of weeks',
  'optForm.recurrenceEndDateOpt': 'Until date',
  'optForm.phWeeksCount': 'Number of repetitions',
  'optForm.ariaRecurrenceEndMethod': 'How the series ends',
  'optForm.ariaRecurrenceWeeks': 'Weeks to repeat',
  'optForm.ariaRecurrenceEndDate': 'Series end date',

  'optForm.labelLocation': 'Location',
  'optForm.labelGymName': 'Gym name *',
  'optForm.phGymName': 'Enter gym name',
  'optForm.labelGymAddress': 'Gym address',
  'optForm.phGymAddress': 'Enter address',
  'optForm.saving': 'Saving…',
  'optForm.save': 'Save',
  'optForm.selectLocation': 'Select location',
  'optForm.online': 'Online',
  'optForm.addNewGym': '+ Add new gym',

  'optForm.commentLabel': 'Note',
  'optForm.commentPlaceholder': 'Enter a note',
  'optForm.commentApplyAria': 'Apply note to all workouts in this series',
  'optForm.commentApplyAll': 'Apply to all workouts in the series',

  'optForm.deleteWorkout': 'Delete workout',

  'optForm.discardTitle': 'Discard changes?',
  'optForm.discardDesc': 'You have unsaved changes. Are you sure you want to close the form?',
  'optForm.discardConfirm': 'Discard changes',

  'optForm.conflictTitle': 'Another workout is already at this time',
  'optForm.conflictAsk': 'Create anyway?',
  'optForm.conflictBatchHeading': 'Busy slots in the series (weekday, date & time):',
  'optForm.conflictSingleHeading': 'Conflicting workouts:',
  'optForm.clientFallback': 'Client',
  'optForm.conflictWorkoutWhen': '{date} at {time}{end}',
  'optForm.conflictEndDash': ' – {end}',
  'optForm.hide': 'Hide',
  'optForm.showMore': 'Show more ({n})',
  'optForm.conflictNo': 'No',
  'optForm.conflictCreating': 'Creating…',
  'optForm.conflictYes': 'Create anyway',

  'recurrenceUi.type.none': 'Does not repeat',
  'recurrenceUi.type.daily': 'Daily',
  'recurrenceUi.type.weekly': 'Weekly',
  'recurrenceUi.type.monthly': 'Monthly',
  'recurrenceUi.type.weekdays': 'Every weekday',
  'recurrenceUi.type.custom': 'Custom',

  'recurrenceUi.freq.daily': 'Every day',
  'recurrenceUi.freq.weekly': 'Every week',
  'recurrenceUi.freq.monthly': 'Every month',
  'recurrenceUi.freq.yearly': 'Every year',
  'recurrenceUi.freq.interval': 'Every N …',

  'recurrenceUi.interval.days': 'days',
  'recurrenceUi.interval.weeks': 'weeks',
  'recurrenceUi.interval.months': 'months',

  'recurrenceUi.end.never': 'Never end',
  'recurrenceUi.end.count': 'End after N occurrences',
  'recurrenceUi.end.date': 'End on date',

  'recurrenceUi.labelRecurrence': 'Repeat',
  'recurrenceUi.titleCustomSettings': 'Repeat settings',
  'recurrenceUi.labelFrequency': 'Frequency',
  'recurrenceUi.labelInterval': 'Interval',
  'recurrenceUi.labelIntervalType': 'Type',
  'recurrenceUi.labelWeekdays': 'Weekdays',
  'recurrenceUi.labelEnd': 'Ends',
  'recurrenceUi.labelEndCount': 'Occurrence count',
  'recurrenceUi.labelEndDate': 'End date',
  'recurrenceUi.titleEndSection': 'End of repeat',
  'recurrenceUi.labelEndTypeTop': 'Ends',
  'recurrenceUi.labelRepeatCount': 'Number of repeats',
  'recurrenceUi.phRepeatExample': 'e.g. 10',
  'recurrenceUi.hintRepeatCount': 'The workout repeats this many times',
  'recurrenceUi.labelEndDateSection': 'End date',
  'recurrenceUi.hintEndDate': 'Repeats through this date (inclusive)',

  'recurrenceUi.summaryNone': 'Does not repeat',
  'recurrenceUi.summaryPrefix': 'Repeat: ',
  'recurrenceUi.summaryDaily': 'daily',
  'recurrenceUi.summaryWeekly': 'weekly',
  'recurrenceUi.summaryMonthly': 'monthly',
  'recurrenceUi.summaryWeekdays': 'every weekday',
  'recurrenceUi.summaryEveryNDays': 'every {n} days',
  'recurrenceUi.summaryEveryNWeeks': 'every {n} weeks',
  'recurrenceUi.summaryEveryNMonths': 'every {n} months',
  'recurrenceUi.summaryEveryDayFallback': 'every day',
  'recurrenceUi.summaryOnDays': ' on {days}',
  'recurrenceUi.summaryNTimes': ' ({n}×)',
  'recurrenceUi.summaryUntil': ' until {date}',

  'createWorkout.saving': 'Creating…',
  'createWorkout.errPickEndTime': 'Choose the workout end time',
  'createWorkout.errEndAfterStart': 'End time must be after start time',
  'createWorkout.errRecurrenceFrequency': 'Choose how often it repeats',
  'createWorkout.errPickWeekday': 'Select at least one weekday',
  'createWorkout.labelClients': 'Client(s) *',
  'createWorkout.phClients': 'Select a client or start typing a name',
  'createWorkout.phStartTime': 'Pick start date & time',
  'createWorkout.labelEndTime': 'End time *',
  'createWorkout.phEndTime': 'Pick end date & time',
  'createWorkout.phLocation': 'Select or type a location',
  'createWorkout.locationNotFound': 'No location found',
  'createWorkout.locGym': 'Gym',
  'createWorkout.locHome': 'Home',
  'createWorkout.locOutdoor': 'Outdoor',
  'createWorkout.locOnline': 'Online',

  'exerciseAnalytics.tabSummary': 'Summary',
  'exerciseAnalytics.tabHistory': 'History',
  'exerciseAnalytics.progressTitle': 'Progress chart',
  'exerciseAnalytics.progressDesc': 'How your numbers change over time',
  'exerciseAnalytics.metricHeaviestShort': 'Weight',
  'exerciseAnalytics.metricVolumeShort': 'Volume',
  'exerciseAnalytics.metricHeaviestAxis': 'Weight (kg)',
  'exerciseAnalytics.metricVolumeAxis': 'Volume (kg)',
  'exerciseAnalytics.timeWeek': 'Week',
  'exerciseAnalytics.timeMonth': 'Month',
  'exerciseAnalytics.timeYear': 'Year',
  'exerciseAnalytics.timeAll': 'All time',
  'exerciseAnalytics.loadingChart': 'Loading…',
  'exerciseAnalytics.noChartData': 'No data to show',
  'exerciseAnalytics.recordsTitle': 'Personal records',
  'exerciseAnalytics.recordsDesc': 'Best numbers across all sessions',
  'exerciseAnalytics.workingWeight': 'Working weight',
  'exerciseAnalytics.editWorkingWeightTitle': 'Edit working weight',
  'exerciseAnalytics.bestSetVolume': 'Best set volume',
  'exerciseAnalytics.bestSessionVolume': 'Best session volume',
  'exerciseAnalytics.noData': 'No data',
  'exerciseAnalytics.loadingShort': 'Loading…',
  'exerciseAnalytics.editWwDialogTitle': 'Working weight',
  'exerciseAnalytics.editWwDialogDesc':
    'Set a manual working weight for “{name}”. Leave empty to clear it.',
  'exerciseAnalytics.labelWwKg': 'Working weight (kg)',
  'exerciseAnalytics.phWw': 'e.g. 40',
  'exerciseAnalytics.errInvalidWeight': 'Enter a valid weight',
  'exerciseAnalytics.errUpdateWeight': 'Couldn’t update working weight',
  'exerciseAnalytics.saving': 'Saving…',
  'exerciseAnalytics.loadingHistory': 'Loading history…',
  'exerciseAnalytics.unknownDate': 'Unknown date',
  'exerciseAnalytics.openWorkout': 'Open workout',
  'exerciseAnalytics.setN': 'Set {n}',
  'exerciseAnalytics.weight': 'Weight',
  'exerciseAnalytics.reps': 'Reps',
  'exerciseAnalytics.noSetData': 'No set data',
  'exerciseAnalytics.noHistory': 'No history for this exercise',
  'exerciseAnalytics.tooltipHeaviestUpdated': 'Working weight (updated)',
  'exerciseAnalytics.tooltipDate': 'Date: {date}',
  'exerciseAnalytics.kgValue': '{value} kg',
  'exerciseAnalytics.emDash': '—',
};
